<template>
  <div>
    <a-layout id="components-layout-demo-side" style="background: white;">
      <a-layout-sider style="height:100%">
        <SelectTree
          ref="myTree"
          :option="treeOption"
          @selectedTree="receiveData"
        />
      </a-layout-sider>
      <a-layout style="background: white;">
        <div style="padding:15px">
          <data-table ref="dataTable" :option="option"> </data-table>
        </div>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import SelectTree from "@/components/dataTree/SelectTree";
import { DataTable } from "@/components/dataTable";
export default {
  components: {
    SelectTree,
    DataTable
  },
  data() {
    return {
      TreeListData: [],
      DictionaryArray: [],
      option: {},
      slotType: "rowAction",
      extendData: "",
      extendData2: "",
      lockUp: false,
      apiOptions: {},
      formTitle: "",

      treeOption: {
        //URL数据请求地址
        api: "SysParamMenus_List",
        //数据字段
        dataField: "Data",
        //标题字段
        title: "Name",
        //子数组字段
        children: "Childs",
        //选择值字段
        keyValue: "Code",
        //使用模式
        checkMode: "childrenMode"
      }
    };
  },
  created() {
    this.option = {
      form: {
        title: "",
        width: 900,
        content: []
      },
      grid: {}
    };
  },

  methods: {
    AccountItemTypeChange(e) {
      const form = this.$refs.dataTable.getForm();
      let nullState = true;

      const checkArray = this.constSelectArray.AccountItemAttributesArray;
      for (let i = 0; i < checkArray.length; i++) {
        if (e == checkArray[i].Code) {
          form.setFieldData("Attributes", checkArray[i].Select);
          nullState = false;
        }
      }
      if (nullState == true) {
        form.setFieldData("Attributes", []);
      }
    },
    rece(e, Data) {
      this.extendData2 = Data.Text;
    },
    receiveData(Data) {
      var _this = this;

      delete _this.option.headSearch;

      //拿取量产页面field，code
      _this.extendData2 = "";
      _this.$post("MaintenanceType_List").then(res => {
        _this.TreeListData = res;
        _this.$post("EnumDesc_GetList").then(res => {
          _this.DictionaryArray = res.Data.DictionaryFieldType;

          var gridTable = _this.option.grid;
          _this.extendData = Data.treeSelect;
          const ListData = this.TreeListData.Data;
          const checkItemIndex = ListData.findIndex(
            item => item.Name === Data.treeSelect
          );
          const gridColums = [
            {
              title: "序号",
              width: "50px", //宽度
              align: "center", //对齐方式
              type: "indexcolumn" // 类型，indexcolumn = 序号
            }
          ];
          var formContent = [];
          //------------------常规量产页面--------------------------------------------//
          _this.apiOptions = {
            api: "MaintenancePage_List",
            params: { Type: Data.treeSelect },
            addApi: "Maintenance_Add",
            getApi: "Maintenance_Get",
            editApi: "Maintenance_Edit",
            delApi: "Maintenance_Del"
          };
          _this.option.form.edit = {
            infoApi: _this.apiOptions.getApi,
            submitApi: _this.apiOptions.editApi,
            onSubmitBefore: values => {
              values.Type = _this.extendData;
              return values;
            }
          };
          if (Data.specialMode == true) {
            delete _this.option.form.add;
            delete _this.option.form.del;
          } else {
            _this.option.form.add = {
              submitApi: _this.apiOptions.addApi,
              onSubmitBefore: values => {
                values.Type = _this.extendData;
                return values;
              }
            };
            _this.option.form.del = {
              submitApi: _this.apiOptions.delApi,
              onSubmitBefore: values => {
                return values;
              }
            };
          }

          gridTable.api = _this.apiOptions.api;
          gridTable.params = _this.apiOptions.params;

          _this.$refs.dataTable.updateSearchContent({
            colnum: 2,
            content: []
          });

          const checkItem = ListData[checkItemIndex];
          _this.option.form.title = checkItem.DisplayName;
          const fields = checkItem.Fields;
          const inputs = {
            0: "input",
            1: "textarea",
            2: "number",
            3: "number",
            4: "time",
            5: "date",
            6: "select",
            7: "checkbox-group"
          };
          for (let i = 0; i < fields.length; i++) {
            const field = fields[i];
            if (field.DisplayName == "描述" || field.DisplayName == "名称") {
              _this.lockUp = true;
            } else {
              _this.lockUp = false;
            }
            var formItem = {
              label: field.DisplayName,
              name: field.Name,
              type: inputs[field.DictionaryFieldType],
              props: {
                disabled: _this.lockUp
              }
            };
            var gridItem = {};
            if (field.DictionaryFieldType == 6) {
              formItem.api = this.$config.serverUrl + field.ComboBoxUrl;
              formItem.param = { types: field.ComboBoxParams.Types };
              formItem.dataField = "Data." + field.ComboBoxParams.Types;
              formItem.option = {
                rules: [{ required: field.Required }]
              };
              if (field.Show == true) {
                gridItem = {
                  title: field.DisplayName,
                  dataIndex: field.ComboBoxParams.Types + "Name",
                  align: "center",
                  width: 150
                };
              }
            } else if (field.DictionaryFieldType == 2) {
              formItem.min = 0;
              if (field.Show == true) {
                gridItem = {
                  title: field.DisplayName,
                  dataIndex: field.Name,
                  align: "center",
                  width: 120
                };
              }
            } else {
              if (field.Show == true) {
                gridItem = {
                  title: field.DisplayName,
                  dataIndex: field.Name,
                  align: "center",
                  width: 300
                };
              }
            }
            gridColums.push(gridItem);
            formContent.push(formItem);
          }
          const control = {
            title: "操作",
            dataIndex: "Id",
            width: "160px",
            key: "action",
            align: "center",
            scopedSlots: { customRender: "rowAction" } //插槽 ，rowAction 默认的 编辑、删除 操作按钮插槽，如需其它按钮需自行定义插槽
          };
          gridColums.push(control);
          this.option.grid.columns = gridColums;
          this.$refs.dataTable.updateFormContent("", "", formContent);
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.ant-layout-sider {
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  position: relative;
  background: white;
  min-width: 0;
}
</style>
